import { Line } from "react-chartjs-2"
import { appendGraphColours } from "./helpers"


const LineChart = ({ data }) => {
  data = appendGraphColours(data)
  const chartData = {
    labels: data.labels,
    datasets: data.datasets,
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
        text: "Order Count",
        style: {
          fontSize: "14px",
        },
      },
    },
    scales: {
      x: {
        type: "category",
        grid: {
          display: false,
        },
        title: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        ticks: {
          stepSize: 1,
        },
        title: {
          display: false,
        },
      },
    },
  }
  return (
    <Line data={chartData} options={options} />
  )
}

export default LineChart
